import Cookies from 'js-cookie';
const setCookie = (cookieName, cookieValue) => {
    if (cookieName && cookieValue) {
        Cookies.set(cookieName, cookieValue, { expires: 90 });
    }
};
export const successUrlRedirect = (remoteSuccessUrl, localSuccessUrl, overrideWithLocalSuccessUrl = false) => {
    console.log('Success Url', localSuccessUrl);
    if (localSuccessUrl || remoteSuccessUrl) {
        window.location.href = (overrideWithLocalSuccessUrl && localSuccessUrl) ? localSuccessUrl : remoteSuccessUrl ?? localSuccessUrl ?? '';
    }
    else {
        // refresh the window here
        window.location.reload();
    }
};
const registerOrLoginAction = (res, scrollEl, onHandleSuccess, onHandleFail, localSuccessUrl = undefined, overrideWithLocalSuccessUrl = false, loginActionOverride) => {
    const { success, errors, message, CookieName: cookieName, CookieValue: cookieValue, SuccessUrl: remoteSuccessUrl, } = res;
    if (success) {
        setCookie(cookieName, cookieValue);
        if (loginActionOverride) {
            loginActionOverride();
        }
        else {
            successUrlRedirect(remoteSuccessUrl, localSuccessUrl, overrideWithLocalSuccessUrl);
        }
    }
    else {
        onHandleFail(errors, message);
        if (scrollEl !== null) {
            scrollEl.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
            });
        }
    }
};
export const loginAction = (res, scrollEl, onHandleSuccess, onHandleFail, successUrl = undefined, overrideWithLocalSuccessUrl = false, loginActionOverride) => {
    const { success, errors, message, CookieName: cookieName, CookieValue: cookieValue, SuccessUrl: remoteSuccessUrl, Children: children, } = res;
    if (success) {
        setCookie(cookieName, cookieValue);
        console.log('Success Url', successUrl);
        if (!children) {
            if (loginActionOverride) {
                loginActionOverride();
            }
            else {
                successUrlRedirect(remoteSuccessUrl, successUrl, overrideWithLocalSuccessUrl);
            }
        }
        else {
            // ignoring as I don't want to risk children returning if an empty array since there's no return here
            // eslint-disable-next-line no-lonely-if
            if (children.length === 0) {
                if (loginActionOverride) {
                    loginActionOverride();
                }
                else {
                    successUrlRedirect(remoteSuccessUrl, successUrl, overrideWithLocalSuccessUrl);
                }
            }
            else {
                return children;
            }
        }
    }
    else {
        onHandleFail(errors, message);
        if (scrollEl !== null) {
            scrollEl.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
            });
        }
    }
};
export default registerOrLoginAction;
